import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

import ListadoInscriptoPsico from "./ListadoInscriptoPsico";
import LectorQrPresente from "../Inscripciones/LectorQrPresente";

const API =
  "https://wwwa.isepsantafe.net.ar/expedientes/ingresos";

// 🧠 HELPER VISIBILIDAD
const puedeVer = (item, rol) => {
  if (!item.visible) return true;

  const visibles = item.visible
    .split(",")
    .map((v) => v.trim());

  if (visibles.includes("Oculto")) return false;
  if (visibles.includes("Todos")) return true;

  return visibles.includes(rol);
};

const ProcesosPsicoViewer = () => {
  const [procesos, setProcesos] = useState([]);

  const [
    procesoSeleccionado,
    setProcesoSeleccionado,
  ] = useState(null);

  const [loading, setLoading] = useState(false);
  const [etapaAbierta, setEtapaAbierta] = useState(null);

  // =========================
  // MODAL PRESENTE
  // =========================
  const [
    modalPresente,
    setModalPresente,
  ] = useState(false);

  const [
    etapaPresente,
    setEtapaPresente,
  ] = useState(null);

  // Presente recién creado por Psicología.
  // Se lo pasamos al listado para pintarlo sin hacer
  // otra consulta al backend.
  const [
    presenteNuevoPsico,
    setPresenteNuevoPsico,
  ] = useState(null);

  // =========================
  // MODAL MATRICULA
  // =========================
  const [
    modalMatricula,
    setModalMatricula,
  ] = useState(false);

  const [
    etapaSeleccionada,
    setEtapaSeleccionada,
  ] = useState(null);

  const [dnisTexto, setDnisTexto] = useState("");
  const [enviando, setEnviando] = useState(false);

  // =========================
  // API PROCESOS
  // =========================
  const cargarProcesos = async () => {
    try {
      const res = await axios.post(
        `${API}/listarProcesos`
      );

      setProcesos(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const abrirProceso = async (proceso) => {
    setLoading(true);

    Swal.fire({
      title: "Cargando proceso...",
      text: "Por favor espere",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const res = await axios.post(
        `${API}/getProcesoCompleto`,
        {
          proceso_id: proceso.id,
        }
      );

      setProcesoSeleccionado(res.data);
    } catch (err) {
      console.error(err);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo cargar el proceso",
      });
    } finally {
      setLoading(false);
      Swal.close();
    }
  };

  useEffect(() => {
    cargarProcesos();
  }, []);

  // =========================
  // HELPERS
  // =========================
  const parseDnis = (texto) => {
    return texto
      .split(/[\s,;\n]+/)
      .map((d) => d.trim())
      .filter((d) => d.length > 0);
  };

  const enviarMatricula = async () => {
    const dnis = parseDnis(dnisTexto);

    if (dnis.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Atención",
        text: "Ingresá al menos un DNI",
      });

      return;
    }

    setEnviando(true);

    try {
      await axios.post(
        `${API}/inscribirMasivoEtapa`,
        {
          dnis,
          proceso_id:
            procesoSeleccionado.id,
          proceso_etapa_id:
            etapaSeleccionada.id,
        }
      );

      Swal.fire({
        icon: "success",
        title: "Matriculación exitosa",
      });

      setModalMatricula(false);
      setDnisTexto("");
    } catch (err) {
      console.error(err);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error al matricular",
      });
    } finally {
      setEnviando(false);
    }
  };

  // =========================
  // DETALLE PROCESO
  // =========================
  if (procesoSeleccionado) {
    return (
      <div className="pv-container">

        {/* ========================= */}
        {/* MODAL PRESENTE */}
        {/* ========================= */}

        {modalPresente && etapaPresente && (
          <div className="pv-modal-overlay">
            <div className="pv-modal">

              <h3>
                📷 Marcar presente
              </h3>

              <p>
                Etapa:{" "}
                <b>
                  {etapaPresente?.nombre}
                </b>
              </p>

              <p
                style={{
                  marginTop: 4,
                  opacity: 0.8,
                }}
              >
                Dependencia:{" "}
                <b>Psicologia</b>
              </p>

              <LectorQrPresente
                etapa_id={
                  etapaPresente?.id
                }
                dependencia="Psicologia"
                onPresenteMarcado={(
                  registro
                ) => {
                  setPresenteNuevoPsico({
                    ...registro,

                    proceso_etapa_id:
                      registro?.proceso_etapa_id ||
                      etapaPresente?.id,

                    dependencia:
                      registro?.dependencia ||
                      "Psicologia",
                  });
                }}
                onClose={() => {
                  setModalPresente(false);
                  setEtapaPresente(null);
                }}
              />

            </div>
          </div>
        )}

        {/* ========================= */}
        {/* MODAL MATRICULA */}
        {/* ========================= */}

        {modalMatricula && (
          <div className="pv-modal-overlay">
            <div className="pv-modal">

              <h3>
                🎓 Matricular en etapa
              </h3>

              <p>
                Etapa:{" "}
                <b>
                  {etapaSeleccionada?.nombre}
                </b>
              </p>

              <textarea
                rows={6}
                placeholder="Pegá DNIs"
                value={dnisTexto}
                onChange={(e) =>
                  setDnisTexto(
                    e.target.value
                  )
                }
                style={{
                  width: "100%",
                }}
              />

              <div
                style={{
                  marginTop: 10,
                }}
              >
                <button
                  className="pv-btn"
                  onClick={
                    enviarMatricula
                  }
                  disabled={
                    enviando
                  }
                >
                  {enviando
                    ? "Enviando..."
                    : "Enviar"}
                </button>

                <button
                  className="pv-btn pv-btn-secondary"
                  onClick={() =>
                    setModalMatricula(
                      false
                    )
                  }
                >
                  Cancelar
                </button>
              </div>

            </div>
          </div>
        )}

        {/* ========================= */}
        {/* VOLVER */}
        {/* ========================= */}

        <button
          className="pv-back"
          onClick={() => {
            setProcesoSeleccionado(
              null
            );

            setEtapaAbierta(null);
          }}
        >
          ← Volver
        </button>

        <h2 className="pv-title">
          {procesoSeleccionado.nombre}
        </h2>

        {loading && (
          <p>Cargando proceso...</p>
        )}

        {/* ========================= */}
        {/* ETAPAS */}
        {/* ========================= */}

        {procesoSeleccionado.etapas?.map(
          (etapa) => {
            const abierta =
              etapaAbierta === etapa.id;

            return (
              <div
                key={etapa.id}
                className="pv-card"
              >

                <div
                  className="pv-header"
                  onClick={() =>
                    setEtapaAbierta(
                      abierta
                        ? null
                        : etapa.id
                    )
                  }
                >
                  <span>
                    {etapa.nombre}
                  </span>

                  <span className="pv-toggle">
                    {abierta
                      ? "−"
                      : "+"}
                  </span>
                </div>

                {abierta && (
                  <div className="pv-body">

                    {/* ========================= */}
                    {/* ACCIONES */}
                    {/* ========================= */}

                    <div
                      style={{
                        marginBottom: 15,
                        display: "flex",
                        gap: 10,
                        flexWrap: "wrap",
                      }}
                    >
                      <button
                        type="button"
                        className="pv-btn"
                        onClick={() => {
                          setEtapaPresente(
                            etapa
                          );

                          setModalPresente(
                            true
                          );
                        }}
                      >
                        📷 Dar presente
                      </button>

                      <button
                        type="button"
                        className="pv-btn"
                        onClick={() => {
                          setEtapaSeleccionada(
                            etapa
                          );

                          setDnisTexto("");

                          setModalMatricula(
                            true
                          );
                        }}
                      >
                        🎓 Matricular
                      </button>
                    </div>

                    {/* ========================= */}
                    {/* LISTADO */}
                    {/* ========================= */}

                    <div
                      style={{
                        marginTop: 15,
                      }}
                    >
                      <ListadoInscriptoPsico
                        etapa={etapa}
                        presenteNuevo={
                          presenteNuevoPsico
                        }
                      />
                    </div>

                  </div>
                )}

              </div>
            );
          }
        )}

      </div>
    );
  }

  // =========================
  // LISTA PROCESOS
  // =========================
  return (
    <div className="pv-container">

      <div className="pv-grid">

        {procesos.map((p) => (
          <div
            key={p.id}
            className="pv-proceso-card"
            onClick={() =>
              abrirProceso(p)
            }
          >
            <h3>
              {p.nombre?.trim()
                ? p.nombre
                : `Proceso #${p.id}`}
            </h3>

            <p
              style={{
                opacity: 0.7,
              }}
            >
              {p.descripcion?.trim()
                ? p.descripcion
                : "Sin descripción"}
            </p>
          </div>
        ))}

      </div>

    </div>
  );
};

export default ProcesosPsicoViewer;
